module.exports = __webpack_public_path__ + "img/ctrl-rz-theta-1.645f5409.svg";